import {ResultsModel} from '../model/results.model';
import {NavigateFunction} from 'react-router-dom';

export const clearResultsContext = (resultsCtx: ResultsModel, navigate: NavigateFunction): void => {

    resultsCtx.onDateOfBirth(null);

    Object.keys(resultsCtx).forEach((key) => {
        if (key.startsWith('on') && typeof resultsCtx[key] === 'function') {
            resultsCtx[key](false);
        }
    });

    navigate('/');
};
